import { TopicResult } from "common/topic/dto/TopicResult";
import {
  InputWayTextCharElement,
  inputWayTextCharElementsGet,
  inputWayTextFieldGet,
} from "common/topic/input_way_text";
import { useCharacterSearch } from "hooks/asocijator/character/useCharacterSearch";
import React from "react";

export function useTextCharSplit(
  topic: TopicResult
): InputWayTextCharElement[] {
  const characterListResult = useCharacterSearch({
    limit: 0,
    skip: 0,
    topicId: topic.id,
  });

  const res: InputWayTextCharElement[] = React.useMemo(() => {
    let elements: InputWayTextCharElement[] = [];
    const textContent = inputWayTextFieldGet(topic);
    if (
      characterListResult &&
      characterListResult.items.length > 0 &&
      textContent.length > 0
    ) {
      elements = inputWayTextCharElementsGet(
        textContent,
        characterListResult.items
      );
    }

    return elements;
  }, [characterListResult]);

  return res;
}
